import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelItemStatusRow } from '@/types/dashboard';
import type { EndpointResponse } from '@/types/endpoints';
import { isValidTimeZone } from '@/utils/orgCalendar';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = {
  subscriptionId: number;
  days: number;
  timezone: string;
};

const validate = ({ subscriptionId, days, timezone }: RequestParams): void => {
  if (!Number.isSafeInteger(subscriptionId) || subscriptionId < 1) throw new Error('Subscription ID must be a positive safe integer');
  if (!Number.isSafeInteger(days) || days < 1) throw new Error('Days must be a positive safe integer');
  if (!isValidTimeZone(timezone)) throw new Error('Valid timezone is required');
};

export const getChannelItemStatusBySubscription = async (
  scope: RequestScope,
  params: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<ChannelItemStatusRow[]>> => {
  try {
    validate(params);

    // This endpoint compares against a Date boundary, so interval N includes N+1 days.
    const result = await scopedApi(scope).get<EndpointResponse<ChannelItemStatusRow[]>>(
      `metrics/channel_item_status_by_subscription/${params.subscriptionId}`,
      {
        ...options,
        params: { interval: params.days - 1, final: 1, tz: params.timezone },
      }
    );
    return result.data;
  } catch (error) {
    return utils.error.handleAxiosError(error);
  }
};
